import type { ReactNode } from 'react';

interface SectionTitleProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
  action?: ReactNode;
}

export default function SectionTitle({
  eyebrow,
  title,
  desc,
  align = 'left',
  action,
}: SectionTitleProps) {
  const isCenter = align === 'center';
  return (
    <div
      className={`flex flex-col gap-4 md:flex-row md:items-end ${
        isCenter ? 'md:justify-center md:text-center' : 'md:justify-between'
      }`}
    >
      <div className={isCenter ? 'mx-auto max-w-2xl' : 'max-w-2xl'}>
        {eyebrow && (
          <p className="mb-2 flex items-center gap-2 text-xs font-medium uppercase tracking-[0.2em] text-primary-600">
            <span className="h-3 w-1 rounded-full bg-primary-500" />
            {eyebrow}
          </p>
        )}
        <h2 className="text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">{title}</h2>
        {desc && <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p>}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}